<template>
    <!-- 教联体端首页 96 -->
    <div class="boss">
        <el-card style="width: 100%; height: 9%; border-radius: 15px;">
            <el-select clearable size="small" placeholder="选择学校" v-model="schoolId" @change="schoolChange">
                <el-option v-for="item in school_list" :label="item.school_name" :value="item.id" :key="item.id"></el-option>
            </el-select>
        </el-card>
        <div class="item">
            <statistics ref="statistics" :schoolId="String(schoolId)"></statistics>
        </div>
        <div class="item">
            <echartsData ref="echartsData" :schoolId="String(schoolId)"></echartsData>
        </div>
    </div>
</template>

<script>
import statistics from '@/components/homePage/educationHomePage/statistics'
import echartsData from '@/components/homePage/educationHomePage/echartsData'

import { unionHomeApi, uniResViewApi } from '@/api/index'
export default {
    components: {
        statistics,
        echartsData
    },
    data() {
        return {
            schoolId: '',
            school_list: [],
        }
    },
    mounted() {
        this.getUniResView();
    },
    methods: {
        schoolChange(e) {
            if (e) {
                this.$refs.statistics.change(e);
                this.$refs.echartsData.change(e);
            }
        },
        // 获取列表-接口
        async getUniResView() {
            const res = await this.axios.post(uniResViewApi);
            if (res.data.code == 1) {
                this.school_list = res.data.data;
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: "error",
                });
            }
        },

    }
}
</script>

<style lang="scss" scoped>
// 教联体端首页-校长
.boss {
    min-width: 1030px;
    height: 87vh;
    overflow-y: auto;
    overflow-x: hidden;

    padding: 20px;
    background-color: #eee;
    .item {
        margin-top: 15px;
        // height: 200px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/homePage/educationHomePage/educationHome.vue